export const Roledata=["software developer","backend engineer","frontend engineer"]
export const Companydata=["Microsoft","OneLogin","Cased","Fluidra North","BusPatrol","Bison Technologies","Sharecare GmbH","universitytees","Netguru S.A.","Sticker Mule","Smaply","Axios","TELUS","AXOVISION","Sensorberg","Brazen Technology","Kinscape","GOhiring","Solo Technologies","Ben Kinney Group Of Companies"]
export const Jobtypedata=["developer","Architecture","designer"]
export const Minimumsalary=["100000","200000","300000","400000","500000","600000","700000","800000"]
export const Maximumsalary=["100000","200000","300000","400000","500000","600000","700000","800000","900000","1000000","1100000","1200000","1300000","1400000","1500000"]
export const ImageCarousel=["https://media.monsterindia.com/trex/prod-cdn/media/promotedemployer/2018/october/lqRJeN6P7CjlvdVeZyaukhZdQ9NZfzosMNk6C1jn.jpeg ",
"https://media.monsterindia.com/trex/prod-cdn/media/promotedemployer/2020/august/MecrAVa1MDfcbSZMvRU4vCYyQC2FApFmfhc0wfHl.jpeg",
"https://media.monsterindia.com/trex/prod-cdn/media/promotedemployer/2020/july/9M4jEIAPbXZSAUGcrw9i9brUAdAdb1PQK4V0xOYq.jpeg",
"https://media.monsterindia.com/trex/prod-cdn/media/promotedemployer/2020/august/uzssgpstR2znKBh7uuT7SE0unho9ARz7bJrMP2xE.jpeg",
"https://media.monsterindia.com/trex/prod-cdn/media/promotedemployer/2020/october/kGHyJcoJiZs2fI79ex1alJM0PRQbN2v8Bk62L16m.jpeg",
"https://media.monsterindia.com/trex/prod-cdn/media/promotedemployer/2021/january/kqZCdMgDlc1oIqXoTYSGmJcNAH4x7GW7I3UnLW1V.jpeg",
"https://media.monsterindia.com/trex/prod-cdn/media/promotedemployer/2021/february/VZ7oNYE6eq9JuMMIqkeDIg6WYzQtqXmM4OWEqMN8.jpeg",
"https://media.monsterindia.com/trex/prod-cdn/media/promotedemployer/2021/march/LX0enPHH5vPMuiu6zxzn80kUVb9LbGc3EFmX2xIH.jpeg",
"https://media.monsterindia.com/trex/prod-cdn/media/promotedemployer/2021/march/y2B7UGXabJ0mOar7ihkzFPkFGV4navbujoSeg80V.jpeg",
"https://media.monsterindia.com/trex/prod-cdn/media/promotedemployer/2021/march/g3es8MZgIi3qJs6E9Y3LrvRzrLJwgyFbWC0zbHOW.jpeg",
"https://media.monsterindia.com/trex/prod-cdn/media/promotedemployer/2021/april/S7ByOesIGjQTu8FVfyGsPsQUfJc5jBXk5uzowf80.jpeg"]

export const TipImage=[{image:"https://media.monsterindia.com/seeker_2014/social/careercenter/taxation.png",
                        title:"Taxtion and Savings"},
                        {image:"https://media.monsterindia.com/seeker_2014/social/careercenter/taxation.png",
                        title:"Taxtion and Savings"},
                        {image:"https://media.monsterindia.com/seeker_2014/social/careercenter/icon_startup.png",
                        title:"Startups"},
                        {image:"https://media.monsterindia.com/seeker_2014/social/careercenter/icon_cii.png",
                        title:"Special Ability"},
                        {image:"https://media.monsterindia.com/seeker_2014/social/careercenter/icon_women.png",
                        title:"Career Women"},
                        {image:"https://media.monsterindia.com/seeker_2014/social/careercenter/job_hunt_strategy.png",
                        title:"Job Search Strategy"},
                        {image:"https://media.monsterindia.com/seeker_2014/social/careercenter/icon_sit.png",
                        title:"Motivation & Leadership"},
                        {image:"https://media.monsterindia.com/seeker_2014/social/careercenter/icon_contract_article.png",
                        title:"Second Career option"},
                        {image:"https://media.monsterindia.com/seeker_2014/social/careercenter/salary_benefits.png",
                        title:"Salary Negotiation"},
                        {image:"https://media.monsterindia.com/seeker_2014/social/careercenter/icon_resume_center.png",
                        title:"Resume & Cover letters"},
                        {image:"https://media.monsterindia.com/seeker_2014/social/careercenter/icon_life_at_work.png",
                        title:"Work life balance"},
                        {image:"https://media.monsterindia.com/seeker_2014/social/careercenter/Icon_interview_center.png",
                        title:"Interview Tips"},
                        {image:"https://media.monsterindia.com/seeker_2014/social/careercenter/icon_career_new.png",
                        title:"Career Management"}]

export const TrendigArticle=["5 Easy Steps to Make a Career Transition from a Software Developer to a Business Analyst",
                             "8 Tips to Launch a Career in Java Development as a Fresher",
                            "6 Popular IT Jobs in India",
                            "7 Skills to Fast-Track Your Career as a Web Developer",
                            "5 Tips to Stay a Step Ahead and Get a Python Job as a Fresher"]                        


export const Tips=[
    {title:"Auto Suggested Keywords",
    details :"Use auto suggested keywords instead of typing for quick job search results." },
    {title: "Advance Search Options",
    details :"Search jobs by freshness, salary, company jobs and placement agency jobs." },
     {title:"Urgent Jobs",
    details :"Use Walk-in Jobs to get a job fast Walk-in Jobs provide direct access to the walk-in opportunities available with top companies." },
    {title:"Exact Job Search",
    details :"Looking for an keyword search?Put double quotes around the keyword to search for exact word/phrases." }
  ]
  export const pending=[
    {
      title:"Resume",
      action:"Add 30%",
    },
    {
      title:"Verify Email Id",
      action:"Add 7%",
    },
    {
      title:"Profile Picture",
      action:"Add 2%",
    },
    {
      title:"Role",
      action:"Add 2%",
    },
    {
      title:"Preferred Location",
      action:"Add 3%",
    },
    {
      title:"Skills",
      action:"Add 8%",
    },
    {
      title:"Course And Certification",
      action:"Add 7%",
    },
    {
      title:"Projects",
      action:"Add 9%",
    }
  ]
  export const UserData=[
    {
      title:"Resume",
      details:"A must to get the attention of recruiters to Find Better Jobs. Faster.",
    },
    {
      title:"Skills",
      details:"Helps recruiter in finding you for relevant jobs.",
    },
    {
      title:"IT Skills",
      details:"Helps recruiter in finding you for relevant jobs.",
    },
    {
      title:"Work Experience",
      details:"Helps recruiters map your candidature against job vacancies they may have.",
    },
    {
      title:"Educational Details",
      details:"Add your Education details to increase your chances of getting a job faster",
    },
    {
      title:"Projects",
      details:"Add projects that you want to showcase.",
    },
    {
      title:"Courses & Certifications",
      details:"Enter details of any professional course or certification you may have done.",
    },
    {
      title:"Languages Known",
      details:"Add the languages you know.",
    },
    {
      title:"Awards & Achievements",
      details:"Enter details of any awards you may have received.",
    },
    {
      title:"Online Presence",
      details:"Enter URL of your Facebook/Twitter/LinkedIn profiles",
    }

  ]